import { useRender } from "@base-ui-components/react/use-render";
import { mergeProps } from "@base-ui-components/react/merge-props";
import { linkClasses, LinkVariants } from "./Link.style";
import { ReactNode } from "react";

export type LinkProps = useRender.ComponentProps<"a"> &
  LinkVariants & {
    href?: string;
    children?: ReactNode;
    className?: string;
  };

const Link = (props: LinkProps) => {
  const { render, variant, underline, color, className, children, ...rest } =
    props;

  const element = render ?? <a />;

  const defaultProps: useRender.ElementProps<"a"> = {
    children,
    className: linkClasses({ variant, underline, color, class: className }),
  };

  const renderElement = useRender({
    render: element,
    props: mergeProps<"a">(defaultProps, rest),
  });

  return renderElement;
};

export default Link;
